import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

interface AgentCanvasToolbarSlotContextValue {
  slot: HTMLElement | null;
  setSlot: (el: HTMLElement | null) => void;
}

const AgentCanvasToolbarSlotContext =
  createContext<AgentCanvasToolbarSlotContextValue | null>(null);

export const AgentCanvasToolbarSlotProvider = ({ children }: { children: ReactNode }) => {
  const [slot, setSlotState] = useState<HTMLElement | null>(null);
  const setSlot = useCallback((el: HTMLElement | null) => setSlotState(el), []);
  const value = useMemo(() => ({ slot, setSlot }), [slot, setSlot]);
  return (
    <AgentCanvasToolbarSlotContext.Provider value={value}>
      {children}
    </AgentCanvasToolbarSlotContext.Provider>
  );
};

export const useAgentCanvasToolbarSlot = (): HTMLElement | null => {
  const ctx = useContext(AgentCanvasToolbarSlotContext);
  return ctx?.slot ?? null;
};

export const useSetAgentCanvasToolbarSlot = (): ((el: HTMLElement | null) => void) => {
  const ctx = useContext(AgentCanvasToolbarSlotContext);
  return ctx?.setSlot ?? (() => {});
};
